/**
 * PI item
 * @param {*} editor
 */
function pi(editor) {
  const cm = editor.codemirror;
  const output = '@';
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'PI',
    action: pi,
    className: 'piicon',
    title: 'PI',
  };

  return option;
}
